import { Input, Select } from '@seiue/ui'
import { isNil } from '@seiue/util'
import { Form, FormInstance } from 'antd'
import { useEffect, useState, forwardRef } from 'react'
import styled from 'styled-components'

import { $t } from 'packages/locale'
import { Notification } from 'packages/sdks-next/growp'

import { NoticeEditor } from '@/components/NoticeEditor'
import { RichTextEditorRef } from 'packages/components/RichText/Editor/types'

type NewsEditorProps = {
  form: FormInstance<{ title: string; content: string; isLink?: boolean }>
  onValuesChange?: () => void
  notification?: Notification
  justEditContent?: boolean
}

/**
 * 资讯编辑
 *
 * @param param0 - 参数
 * @param param0.form - 表单
 * @param param0.notification - 通知
 * @param param0.onValuesChange - 表单值变化回调
 * @param param0.justEditContent - 只编辑内容
 * @returns 组件
 */
export const NewsEditor = forwardRef<RichTextEditorRef, NewsEditorProps>(
  ({ form, notification, onValuesChange, justEditContent }, ref) => {
    const isLink = form.getFieldValue('isLink')
    const [type, setType] = useState<'link' | 'text'>('link')

    useEffect(() => {
      if (!isNil(isLink)) {
        setType(isLink ? 'link' : 'text')
      }
    }, [isLink])

    return (
      <Wrapper>
        {justEditContent ? null : (
          <Select.Segmented
            value={type}
            options={[
              {
                label: $t('链接资讯'),
                value: 'link',
              },
              {
                label: $t('文本资讯'),
                value: 'text',
              },
            ]}
            onChange={(val) => {
              setType(val)
              form.setFieldValue('isLink', val === 'link')
              form.setFieldValue('content', undefined)
              onValuesChange?.()
            }}
          />
        )}
        {type === 'link' ? (
          <Form
            form={form}
            initialValues={{
              title: notification?.title,
              content: notification?.content,
            }}
            onValuesChange={onValuesChange}
          >
            <Form.Item
              name="title"
              rules={[
                {
                  required: true,
                  message: $t('请输入资讯标题'),
                },
              ]}
              label={$t('资讯标题')}
            >
              <Input
                placeholder={$t('请输入资讯标题')}
                maxLength={50}
              />
            </Form.Item>
            <Form.Item
              name="content"
              rules={[
                {
                  required: true,
                  message: $t('请输入资讯链接'),
                },
                // 校验是否是有效链接
                {
                  type: 'url',
                  message: $t('请输入有效的链接'),
                },
              ]}
              label={$t('资讯链接')}
              style={{
                marginBottom: 0,
              }}
            >
              <Input placeholder={$t('请输入资讯链接')} />
            </Form.Item>
          </Form>
        ) : (
          <NoticeEditor
            form={form}
            initialValues={{
              title: notification?.title,
              content: notification?.content,
            }}
            onValuesChange={onValuesChange}
            titlePlaceholder={$t('请输入资讯标题')}
            richTextPlaceholder={$t('请输入资讯详情')}
            ref={ref}
          />
        )}
      </Wrapper>
    )
  }
)

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
  .ant-segmented {
    width: fit-content;
  }
`
